import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CountUp from "react-countup";

const StudentDashboard = () => {
  const routes = all_routes;
  const [showFABModal, setShowFABModal] = useState(false);

  // Mock data for alerts
  const smartAlerts = [
    {
      type: "urgent",
      message: "Math test tomorrow - Chapter 5",
      time: "2 hours ago",
    },
    {
      type: "warning",
      message: "Physics homework due today",
      time: "4 hours ago",
    },
    {
      type: "info",
      message: "Science fair registration closes Friday",
      time: "1 day ago",
    },
  ];

  // Mock data for events
  const upcomingEvents = [
    {
      title: "Science Fair",
      date: "Aug 15",
      description: "Annual Exhibition",
      type: "academic",
    },
    {
      title: "Math Test",
      date: "Tomorrow",
      description: "Chapter 5",
      type: "exam",
    },
    {
      title: "Parent Meeting",
      date: "Aug 9",
      description: "3:00 PM",
      type: "meeting",
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Student Dashboard</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Welcome Card */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-info">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Welcome back, Sarah!</h3>
                      <p>Ready to learn something new today?</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-user-star text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Smart Alerts Widget */}
            <div className="col-xxl-6 col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Smart Alerts</h4>
                </div>
                <div className="card-body">
                  <div className="alert-list">
                    {smartAlerts.map((alert, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-3"
                      >
                        <div
                          className={`avatar avatar-sm me-3 ${
                            alert.type === "urgent"
                              ? "bg-danger"
                              : alert.type === "warning"
                              ? "bg-warning"
                              : "bg-info"
                          }`}
                        >
                          <i
                            className={`ti ${
                              alert.type === "urgent"
                                ? "ti-alert-triangle"
                                : alert.type === "warning"
                                ? "ti-clock"
                                : "ti-info-circle"
                            } text-white`}
                          ></i>
                        </div>
                        <div className="flex-fill">
                          <p className="mb-1 fw-semibold">{alert.message}</p>
                          <small className="text-muted">{alert.time}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Events Widget */}
            <div className="col-xxl-6 col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Upcoming Events</h4>
                </div>
                <div className="card-body">
                  <div className="events-list">
                    {upcomingEvents.map((event, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-3 p-2 bg-light rounded"
                      >
                        <div
                          className={`avatar avatar-sm me-3 ${
                            event.type === "academic"
                              ? "bg-primary"
                              : event.type === "exam"
                              ? "bg-warning"
                              : "bg-info"
                          }`}
                        >
                          <i
                            className={`ti ${
                              event.type === "academic"
                                ? "ti-calendar"
                                : event.type === "exam"
                                ? "ti-school"
                                : "ti-users"
                            } text-white`}
                          ></i>
                        </div>
                        <div className="flex-fill">
                          <h6 className="mb-1">{event.title}</h6>
                          <p className="text-muted mb-0">
                            {event.date} • {event.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard Widgets Row */}
          <div className="row">
            {/* Attendance Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-success-transparent me-2">
                      <i className="ti ti-calendar-check fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-success">
                          <CountUp end={92} />%
                        </h2>
                        <span className="badge bg-success">Excellent</span>
                      </div>
                      <p>Attendance Overview</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Present:{" "}
                      <span className="text-success fw-semibold">147</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Absent:{" "}
                      <span className="text-danger fw-semibold">13</span>
                    </p>
                  </div>
                  <Link
                    to={routes.attendanceView}
                    className="btn btn-success btn-sm mt-2 w-100"
                  >
                    View Attendance
                  </Link>
                </div>
              </div>
            </div>

            {/* Today's Classes Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-primary-transparent me-2">
                      <i className="ti ti-calendar-time fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter">
                          <CountUp end={6} />
                        </h2>
                        <span className="badge bg-primary">Today</span>
                      </div>
                      <p>Today's Schedule</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Completed:{" "}
                      <span className="text-success fw-semibold">2</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Remaining:{" "}
                      <span className="text-info fw-semibold">4</span>
                    </p>
                  </div>
                  <Link
                    to={routes.studentTimeTable}
                    className="btn btn-primary btn-sm mt-2 w-100"
                  >
                    View Schedule
                  </Link>
                </div>
              </div>
            </div>

            {/* Homework Overview Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning-transparent me-2">
                      <i className="ti ti-book-2 fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-warning">
                          <CountUp end={4} />
                        </h2>
                        <span className="badge bg-warning">Due</span>
                      </div>
                      <p>Homework Overview</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Submitted:{" "}
                      <span className="text-success fw-semibold">23</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Overdue:{" "}
                      <span className="text-danger fw-semibold">1</span>
                    </p>
                  </div>
                  <Link
                    to={routes.homeworkList}
                    className="btn btn-warning btn-sm mt-2 w-100"
                  >
                    View Homework
                  </Link>
                </div>
              </div>
            </div>

            {/* Grades Summary Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-trophy fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          <CountUp end={87} />%
                        </h2>
                        <span className="badge bg-info">Grade A</span>
                      </div>
                      <p>Grades Summary</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Average:{" "}
                      <span className="text-info fw-semibold">84%</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Rank: <span className="text-success fw-semibold">12</span>
                    </p>
                  </div>
                  <Link
                    to={routes.gradeList}
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    View Grades
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Row */}
          <div className="row">
            {/* Today's Schedule */}
            <div className="col-xxl-8 col-xl-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Today's Class Schedule</h4>
                  <Link
                    to={routes.studentTimeTable}
                    className="btn btn-primary btn-sm"
                  >
                    View Full Schedule
                  </Link>
                </div>
                <div className="card-body">
                  <div className="class-schedule">
                    <div className="d-flex align-items-center mb-3 p-3 bg-success-light rounded">
                      <div className="avatar avatar-sm bg-success me-3">
                        <span className="text-white fw-bold">1</span>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">Mathematics</h6>
                        <p className="text-muted mb-0">
                          Room 201 • 9:00 AM - 9:45 AM • Ms. Johnson
                        </p>
                      </div>
                      <span className="badge bg-success">Completed</span>
                    </div>
                    <div className="d-flex align-items-center mb-3 p-3 bg-success-light rounded">
                      <div className="avatar avatar-sm bg-success me-3">
                        <span className="text-white fw-bold">2</span>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">English Literature</h6>
                        <p className="text-muted mb-0">
                          Room 105 • 10:00 AM - 10:45 AM • Mr. Davis
                        </p>
                      </div>
                      <span className="badge bg-success">Completed</span>
                    </div>
                    <div className="d-flex align-items-center mb-3 p-3 bg-warning-light rounded">
                      <div className="avatar avatar-sm bg-warning me-3">
                        <span className="text-white fw-bold">3</span>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">Physics Lab</h6>
                        <p className="text-muted mb-0">
                          Lab 1 • 11:00 AM - 12:00 PM • Dr. Smith
                        </p>
                      </div>
                      <span className="badge bg-warning">Next Class</span>
                    </div>
                    <div className="d-flex align-items-center mb-3 p-3 bg-light rounded">
                      <div className="avatar avatar-sm bg-info me-3">
                        <span className="text-white fw-bold">4</span>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">History</h6>
                        <p className="text-muted mb-0">
                          Room 302 • 1:00 PM - 1:45 PM • Ms. Wilson
                        </p>
                      </div>
                      <span className="badge bg-info">Upcoming</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Latest Announcements */}
            <div className="col-xxl-4 col-xl-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Latest Announcements</h4>
                  <Link
                    to={routes.studentNoticeBoard}
                    className="btn btn-info btn-sm"
                  >
                    View All
                  </Link>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3 p-3 bg-info-light rounded">
                    <div className="avatar avatar-sm bg-info me-3">
                      <i className="ti ti-bell text-white"></i>
                    </div>
                    <div className="flex-fill">
                      <h6 className="mb-1">Mid-term Exam Schedule</h6>
                      <p className="text-muted mb-0 small">
                        Check your exam dates and prepare accordingly
                      </p>
                      <small className="text-muted">2 hours ago</small>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-3 p-3 bg-warning-light rounded">
                    <div className="avatar avatar-sm bg-warning me-3">
                      <i className="ti ti-calendar text-white"></i>
                    </div>
                    <div className="flex-fill">
                      <h6 className="mb-1">Science Fair Registration</h6>
                      <p className="text-muted mb-0 small">
                        Register by next Friday
                      </p>
                      <small className="text-muted">1 day ago</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAB Button */}
      <div className="floating-btn">
        <button
          className="btn btn-primary rounded-circle"
          style={{
            position: "fixed",
            bottom: "80px",
            right: "20px",
            width: "56px",
            height: "56px",
            zIndex: 1000,
          }}
          onClick={() => setShowFABModal(true)}
        >
          <i className="ti ti-plus"></i>
        </button>
      </div>

      {/* FAB Modal */}
      {showFABModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Quick Actions</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFABModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-grid gap-2">
                  <button className="btn btn-primary text-start">
                    <i className="ti ti-message me-3"></i>
                    Send Message to Teacher
                  </button>
                  <button className="btn btn-warning text-start">
                    <i className="ti ti-book me-3"></i>
                    Submit Homework
                  </button>
                  <button className="btn btn-info text-start">
                    <i className="ti ti-calendar me-3"></i>
                    Request Meeting
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentDashboard;
